import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect } from "react";

export default function AdvertisingCookies() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="advertising-cookies-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 md:px-12 pt-32 pb-[20px]">
        <h1 className="font-heading text-[30px] sm:text-[45px] font-semibold text-[#08122a] tracking-tight leading-tight mb-4">Advertising and Cookies</h1>
        <p className="font-body text-sm text-[#475569] mb-12">Last updated: February 1, 2026</p>

        <div className="space-y-10 font-body text-[#475569] text-base leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">1. What Are Cookies</h2>
            <p>Cookies are small text files stored on your device when you visit a website. They help the website remember your preferences and understand how you interact with the site. Cookies are widely used to make websites function efficiently and to provide reporting information.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">2. How We Use Cookies</h2>
            <p className="mb-3">Nebula Flow uses cookies for the following purposes:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong className="text-[#08122a]">Essential Cookies:</strong> Required for the website to function properly. These cannot be disabled.</li>
              <li><strong className="text-[#08122a]">Analytics Cookies:</strong> Help us understand how visitors interact with our website by collecting and reporting information anonymously.</li>
              <li><strong className="text-[#08122a]">Preference Cookies:</strong> Allow the website to remember choices you make, such as language or region.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">3. Advertising</h2>
            <p>Nebula Flow does not serve third-party advertisements on its website. We do not use advertising cookies or tracking pixels for the purpose of targeted advertising. Any analytics data collected is used solely to improve our website and user experience.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">4. Third-Party Services</h2>
            <p>We may use third-party analytics services (such as Google Analytics) that set their own cookies. These services help us analyze website traffic and usage patterns. The information collected by these cookies is aggregated and anonymous.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">5. Managing Cookies</h2>
            <p>Most web browsers allow you to control cookies through their settings. You can set your browser to refuse cookies or to alert you when cookies are being sent. Please note that disabling cookies may affect the functionality of our website.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">6. Updates to This Policy</h2>
            <p>We may update this Advertising and Cookies policy periodically. Changes will be reflected on this page with an updated revision date.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#08122a] mb-3">7. Contact</h2>
            <p>For questions regarding our use of cookies, please reach out to us at info@nebula-f.com.</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}
